function LandingAnimations() {
    this._dropUp = $('[data-animations="dropup"]');
    this._rotateFlip = $('[data-animations="flip"]');
    this._zoomFlip = $('[data-animations="zoom"]');
    this._listDropUp = $('[data-animations="listdropup"]');
    this._window = $(window);
    this._document = $(document);
}
LandingAnimations.prototype._scrollView = function () {
    const current_position = this._document.scrollTop() + this._window.height();

    this._animateBlocks(this._dropUp, current_position);
    this._animateBlocks(this._rotateFlip, current_position);
    this._animateBlocks(this._zoomFlip, current_position);
    this._animateListUp(current_position);
}
LandingAnimations.prototype._animateBlocks = function (block, position) {
    block.map( (index, item) => {
        const $item = $(item);
        const target = position - $item.height() / 3;
        const offsetTop = $item.offset().top;

        if (offsetTop <= target) {
            $item.addClass('animated');
        }
    })
}

LandingAnimations.prototype._animateListUp = function (position) {
    this._listDropUp.map( (index, item) => {
        const $item = $(item);
        const target = position - $item.height() / 2;
        const offsetTop = $item.offset().top;

        if (offsetTop <= target) {
            const list_items = $(item).children();
            let animation_delay = 300;

            list_items.map( (index, list_item) => {
                $(list_item).css({
                    'transition-delay': animation_delay + 'ms'
                });
                $(list_item).addClass('animated');
                animation_delay += 100;
            })
        }
    });
}

LandingAnimations.prototype.bindEvents = function () {
    const instance = this;

    this._document.on('scroll load resize', function () {
        instance._scrollView();
    })
}
LandingAnimations.prototype.apply = function () {
    this.bindEvents();
}